import { useEffect, useState } from "react";
import Video from "./Video";
import Short from "./Short";
import CollapsibleSection from "./CollapsibleSection";

function AllVideos() {
  const [allVideos, setAllVideos] = useState(null);

  useEffect(() => {
    fetch(`/allVideos.json?timestamp=${new Date().getTime()}`)
      .then((response) => response.json())
      .then((data) => setAllVideos(data));
  }, []);

  if (!allVideos) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div id='bandSongs'>
        <CollapsibleSection title='Νέα τραγούδια της μπάντας'>
          <div className='sectionStyle'>
            {allVideos.bandSongsVids.map((video) => (
              <div key={video.id}>
                <Video video={video} />
              </div>
            ))}
          </div>
        </CollapsibleSection>
      </div>
      <hr className='sectionSeparator' />
      <div id='videos'>
        <CollapsibleSection title='Videos'>
          <div className='sectionStyle'>
            {allVideos.tubeVids.map((video) => (
              <div key={video.id}>
                <Video video={video} />
              </div>
            ))}
          </div>
        </CollapsibleSection>
      </div>
      <hr className='sectionSeparator' />
      <div id='musicStories'>
        <CollapsibleSection title='Μουσικές ιστορίες'>
          <div className='sectionStyle'>
            {allVideos.musicStories.map((video) => (
              <div key={video.id}>
                <Video video={video} />
              </div>
            ))}
          </div>
        </CollapsibleSection>
      </div>
      <hr className='sectionSeparator' />
      <div id='shorts'>
        <CollapsibleSection title='Shorts'>
          <div className='sectionStyle'>
            {allVideos.shortsRow.map((short) => (
              <div key={short.id}>
                <Short short={short} />
              </div>
            ))}
          </div>
        </CollapsibleSection>
      </div>
    </>
  );
}

export default AllVideos;
